<div [ngClass]="{show: _show, hide: !_show}" [ngStyle]="{'max-height': containerHeight}" #outer>
	<div #inner>
		<div class="links">

			<div class="branches">
				<h2><img [src]="'/assets/iconMap.svg'" alt="storage facilities"> Our storage facilities</h2>
				<a class="nav-facility-link" (click)="close.emit()" [routerLink]="['/storage-facility', 'midrand']">Midrand</a>
				<a class="nav-facility-link" (click)="close.emit()" [routerLink]="['/storage-facility', 'sandton']">Sandton</a>
				<a class="nav-facility-link" (click)="close.emit()" [routerLink]="['/storage-facility', 'honeydew']">Honeydew</a>
				<a class="nav-facility-link" (click)="close.emit()" [routerLink]="['/storage-facility', 'pretoria']">Pretoria, Roseville</a>
				<a class="nav-facility-link" (click)="close.emit()" [routerLink]="['/storage-facility', 'pretoria-hatfield']">Pretoria, Hatfield</a>
				<a class="nav-facility-link" (click)="close.emit()" [routerLink]="['/storage-facility', 'centurion']">Centurion</a>
			</div>

			<div>
				<h2><img [src]="'/assets/iconBlog.svg'" alt="useful storage info"> Useful info</h2>
				<a [routerLink]="['/faqs']">FAQs</a>
				<a [routerLink]="['/moving-tips']">Packing &amp; moving tips</a>
				<a [routerLink]="['/free-move-in-transport']">Free move-in transport</a>
				<a [routerLink]="['/payment-terms']"> Payment terms</a>
				<a [routerLink]="['/blog']"> News &amp; articles</a>
			</div>

			<div>
				<h2><img [src]="'/assets/iconStorage.svg'" alt="more about storage"> About us</h2>
				<a [routerLink]="['/facility-standards']">Facility standards</a>
				<a [routerLink]="['/security']">Secure storage</a>
				<a [routerLink]="['/careers']">Careers</a>
			</div>

			<div>
				<h2><img [src]="'assets/iconContact.svg'" alt="contact rent-a-store"> Call us</h2>
				<p>
					Our consultants are available to assist you
				</p>
				<p>
					<a href="tel:+27861736827">0861&nbsp;73&nbsp;68&nbsp;27</a>
				</p>
				<a class="button" [routerLink]="['/contact']">Contact us</a>
			</div>

		</div>

		<div class="packing-supplies">
			<p>
				<img [src]="'/assets/iconBoxWhite.svg'" alt="Packing supplies shop">
				Buy your packing supplies now
				<a target="_blank" href="https://packingsupplies.co.za">Go to shop</a>
			</p>
		</div>
	</div>
</div>